import axios from "../login/api/axios";
import { WebsiteCategories } from "../Shared/sharedInterfaces";
const WEBCATS_URL = "/modules/webcats";
const WEBCAT_UPDATE_URL = "/modules/webcatUpdate";
const OFFCATS_URL = "/modules/offcats";
const OFFCAT_UPDATE_URL = "/modules/offcatUpdate";


interface webCatsFromDatabase {
  success: [
    WebsiteCategories
  ];
}

export async function getWebCatsFromDatabase() {
 const getWebCatsFromDatabase = new Promise<webCatsFromDatabase>((resolve, reject) => {
    const accessToken = sessionStorage.getItem('accessToken')
    axios.get(
      WEBCATS_URL,
        {
          headers: { 
            'Authorization' : 'Bearer ' + accessToken,
            "Content-Type": "application/json",
          },
          withCredentials: true,
        }
    )
    .then(res => {
      if (res) {
        resolve (res.data)
      } else {
        reject ("DB No webcats found")
      }
      })
    .catch(error => {
      console.log ("Error: DB No webcats found: " + error)
    })
  }); 
  const WebCatsFromDatabase = await getWebCatsFromDatabase
  
  return WebCatsFromDatabase
} 

export function updateWebCat(payload: {
  id: number;
  volgorde: number;
  io_type: string;
  typeIcon: string;
  categorie_nl: string;
  categorie_fr: string;
  categorie_en: string;
}) {
  const accessToken = sessionStorage.getItem('accessToken');

  return axios.post(
    WEBCAT_UPDATE_URL,
    JSON.stringify(payload),
    {
      headers: {
        'Authorization': 'Bearer ' + accessToken,
        "Content-Type": "application/json",
      },
      withCredentials: true,
    }
  );
}

export async function getOffCatsFromDatabase() {
  const accessToken = sessionStorage.getItem('accessToken');
  const res = await axios.get(OFFCATS_URL, {
    headers: { 'Authorization': 'Bearer ' + accessToken, "Content-Type": "application/json" },
    withCredentials: true,
  });
  return res.data;
}

export function updateOffCat(payload: {
  id: number;
  volgorde: number;
  categorie_nl: string;
  categorie_fr: string;
  categorie_en: string;
}) {
  const accessToken = sessionStorage.getItem('accessToken');
  return axios.post(OFFCAT_UPDATE_URL, JSON.stringify(payload), {
    headers: { 'Authorization': 'Bearer ' + accessToken, "Content-Type": "application/json" },
    withCredentials: true,
  });
}